/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Tracking_Dealclosedsuccessfully3Inputs */

const en_coinvestments_tracking_dealclosedsuccessfully3 = /** @type {(inputs: Coinvestments_Tracking_Dealclosedsuccessfully3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opportunity closed successfully`)
};

/**
* | output |
* | --- |
* | "Opportunity closed successfully" |
*
* @param {Coinvestments_Tracking_Dealclosedsuccessfully3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_tracking_dealclosedsuccessfully3 = /** @type {((inputs?: Coinvestments_Tracking_Dealclosedsuccessfully3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Tracking_Dealclosedsuccessfully3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_tracking_dealclosedsuccessfully3(inputs)
});
export { coinvestments_tracking_dealclosedsuccessfully3 as "coInvestments_tracking_dealClosedSuccessfully" }